<template>
  <container :class="{ 'is-in-sdk': isInSdk }">
    <div
      class="conversation"
      :class="[resolved ? 'resolved' : '', $platformClass]"
      :style="borderHeight"
    >
      <p class="text ceate-time" :class="$platformClass">
        {{ formatedCreateTime }}
      </p>
      <div class="conversation-work">
        <div class="work-card triangle-right" :class="$platformClass">
          <Title class="text-xl" :class="$platformClass">
            {{ work.SUBJECT }}
          </Title>
          <p
            class="text work-card-message"
            :class="$platformClass"
            style="white-space: pre-wrap"
          >
            {{ work.MESSAGE }}
          </p>
          <div
            class="work-card-images"
            :class="$platformClass"
            v-if="work.SCREEN_PIC[0]"
          >
            <img
              v-image-preview
              alt
              v-for="pic in work.SCREEN_PIC"
              :src="pic"
              :key="pic"
            />
          </div>
        </div>
        <Icon type="userDefaultAvatar" class="portrait-user"></Icon>
      </div>
      <div class="conversation-main">
        <transition-group :name="transition">
          <div
            class="conversation-main-item"
            :class="{ service: !item.LOGIN_ACCOUNT && !item.FINGER_PRINT }"
            v-for="item in conversationList"
            :key="item.CREATE_TIME"
          >
            <div
              class="work-card"
              :class="{
                'triangle-left': !item.LOGIN_ACCOUNT && !item.FINGER_PRINT,
                'triangle-right': item.FINGER_PRINT,
                'is-omni': $isOmni
              }"
            >
              <p
                class="text work-card-message"
                :class="$platformClass"
                style="white-space: pre-wrap"
              >
                {{ item.MESSAGE }}
              </p>
              <div
                class="work-card-images"
                :class="$platformClass"
                v-if="item.SCREEN_PIC[0]"
              >
                <img
                  v-image-preview
                  alt
                  v-for="pic in item.SCREEN_PIC"
                  :src="pic"
                  :key="pic"
                />
              </div>
            </div>
            <Icon
              :type="
                item.FINGER_PRINT ? 'userDefaultAvatar' : 'serviceDefaultAvatar'
              "
              :class="{
                'portrait-service': !item.LOGIN_ACCOUNT && !item.FINGER_PRINT,
                'portrait-user': item.FINGER_PRINT
              }"
            ></Icon>
          </div>
        </transition-group>
      </div>
      <p
        class="conversation-feedback text-s"
        :class="$platformClass"
        v-if="!resolved && canEvaluate"
      >
        {{ letters._solved }}
        <a href="javascript:;" @click="toggleMarkScore">
          <Mark type="contactService">{{ letters._service }}</Mark>
        </a>
      </p>
      <p class="conversation-feedback text-s" v-if="resolved">
        {{ letters._solvedText }}
      </p>
    </div>
    <div class="img-preview-list" :class="$platformClass" v-if="!resolved">
      <div
        :class="$platformClass"
        class="img-preview-list-item"
        v-for="(image, i) in previewList"
        :key="i"
      >
        <img :src="image" alt v-image-preview />
        <div class="loading" v-if="showLoading && i === previewList.length - 1">
          <i class="loading-icon"></i>
        </div>
        <a
          href="javascript:;"
          @click="deleteImage(i)"
          class="img-preview-list-item-delete"
          :class="$platformClass"
        ></a>
      </div>
      <!--第三方图片上传插件-->
      <vue-core-image-upload
        v-if="isEnoughText && previewList.length < 3"
        class="btn btn-primary"
        :class="$platformClass"
        :crop="false"
        @imagechanged="addImage"
        @errorhandle="imageErrorHandle"
        :max-file-size="20971520"
        :multiple="true"
        :text="''"
        :isXhr="false"
        :inputAccept="'image/*'"
        :extensions="'png,jpg,jpeg,gif'"
      >
        <a
          href="javascript:;"
          class="upload-image-btn"
          :class="$platformClass"
        ></a>
      </vue-core-image-upload>
    </div>
    <FooterContainer
      type="supportFooter"
      class="send"
      v-if="!resolved && canReply"
    >
      <SupportReplyInput
        type="text"
        :class="{ dis: resolved, 'is-omni': $isOmni }"
        class="text"
        :placeholder="letters._messageHolder"
        v-model="message"
        :disabled="resolved"
      ></SupportReplyInput>
      <Button
        type="edit"
        @click="send"
        :class="{ dis: resolved }"
        class="text-l"
        :disabled="resolved"
        :loading="loading"
      >
        {{ letters._sendMessage }}
      </Button>
    </FooterContainer>
    <mark-score
      @toggle="toggleMarkScore"
      :open="openMarkScore"
      :support_order_id="work.SUPPORT_ORDER_ID"
    ></mark-score>
  </container>
</template>
<script>
import { TOAST } from '../../store/support/event-type.js';
import container from '../../components/support/Container.vue';
import { mapState, mapActions, mapMutations } from 'vuex';
import getLetters from '../../mixins/getLetters.js';
import formatDate from '../../utiles/formatDate.js';
import VueCoreImageUpload from 'vue-core-image-upload';
import globalConfig from '../../utiles/globalConfig.js';
import markScore from '../../components/support/markScore.vue';
import Compressor from 'compressorjs';
import bridge from '@utiles/bridge';
import { getFileExtension } from '../../utiles';

export default {
  name: 'my-work',
  mixins: [getLetters],
  // created: function() {
  //   let workId = this.$route.params.workId;
  //   this.getWorkDetail(workId);
  // },
  data: () => {
    return {
      message: '', // 用户将要发送的消息
      openMarkScore: false, // 控制评分弹窗
      transition: '', // 过渡效果主要用于新增消息，避免作用在整个列表的初始化
      previewList: [], // 预览图片列表，base64格式
      showLoading: false,
      workParams: {
        pic: [],
        pic_compress: [] // 对应图片是否压缩标识别 1:压缩 0:未压缩
      },
      loading: false,
      isInSdk: bridge.runInsdk()
    };
  },
  computed: {
    ...mapState({
      workDetailList: state => state.support.workDetailList,
      resolved: state => {
        let workList = state.support.workDetailList;
        if (workList.length) {
          return workList[0].STATUS === '4';
        } else {
          return false;
        }
      } // 问题是否已解决的标志
    }),
    // 是否可以回复
    canReply() {
      return this.workDetailList[0]?.IS_ABLE_TO_REPLY == 1;
    },
    // 是否可以评价
    canEvaluate() {
      return this.workDetailList[0]?.IS_ABLE_TO_EVALUATE == 1;
    },
    isEnoughText() {
      return this.message.length >= 10;
    },
    formatedCreateTime: function () {
      if (!this.workDetailList.length) {
        return '';
      }
      var work = this.workDetailList[0];
      let date = new Date(work.CREATE_TIME * 1000);
      let time = formatDate(date, 'MM/dd/yyyy');
      return time;
    },

    work: function () {
      if (!this.workDetailList.length) {
        return {
          SCREEN_PIC: []
        };
      }
      return this.workDetailList[0];
    }, // 详情列表的第一项，是提交工单时的信息
    conversationList: function () {
      if (!this.workDetailList.length) {
        return null;
      }
      return this.workDetailList.slice(1);
    }, // 详情列表从第二项开始，是客服与玩家之间的对话
    borderHeight() {
      if (this.resolved) {
        return '';
      }
      let origin = this.$isOmni ? 120 : 130;
      let row = Math.ceil(this.previewList.length / 5) || 1;
      let enoughText = this.isEnoughText ? 0 : 1;
      return `border-bottom-width: ${origin + row * 110 - enoughText * 105}px;`;
    }
  },
  watch: {
    conversationList() {
      this.resetImage();
    },
    $route: {
      deep: true,
      immediate: true,
      handler(to, from) {
        if (to.name !== 'mywork') {
          return;
        }
        this.message = '';
        this.resetImage();
        let workId = this.$route.params.workId;
        this.getWorkDetail(workId);
      }
    }
  },
  methods: {
    ...mapMutations([TOAST]),
    ...mapActions(['getWorkDetail', 'sendMessage', 'uploadImg']),
    addImage(res) {
      function addPic(res, self) {
        let img = res;
        if (img.size > 4 * 1024 * 1024) {
          try {
            new Compressor(
              new window.File([img], img.name, { type: 'image/jpeg' }),
              {
                quality: 0.7,
                success(miniResult) {
                  self.handleUploadImg(miniResult, self, true);
                },
                error(err) {
                  console.log(err.message);
                }
              }
            );
          } catch (error) {
            self.handleUploadImg(img, self, false);
          }
        } else {
          self.handleUploadImg(img, self, false);
        }
      }
      try {
        let len = res.length;
        if (len) {
          for (let i = 0; i < len; i++) {
            addPic(res[i], this);
          }
        } else {
          addPic(res, this);
        }
      } catch (err) {
        console.log(err);
      }
    },
    // handleUploadImgOld(img, self, isCompress) {
    //   let reader = new FileReader();
    //   let vm = self;
    //   reader.onload = function () {
    //     let imgData = this.result;
    //     if (imgData?.length > 9 * 1024 * 1024) {
    //       //大于4MB的图片压缩后base64还是大于9MB，不允许上传 提示上传错误
    //       vm[TOAST](vm.letters._uploadTips);
    //       return;
    //     }
    //     vm.previewList.push(imgData);
    //     vm.showLoading = true;

    //     vm.uploadImg({ content: [imgData] }).then(res => {
    //       let url = (res?.data && res.data?.IMG_URL[0]) || '';
    //       if (res.result === 1) {
    //         vm.showLoading = false;
    //         vm.workParams.pic.push(url);
    //         vm.workParams.pic_compress.push(+isCompress);
    //       } else {
    //         vm.showLoading = false;
    //         vm.toast(res.msg);
    //       }
    //     });
    //   };
    //   reader.readAsDataURL(img);
    // },
    // post请求
    post(url, formData) {
      // 打印时间戳
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              const res = JSON.parse(xhr.responseText);
              if (res.result === 1) {
                console.log(res);
                resolve(res);
              } else {
                reject(res);
              }
            } else {
              reject(xhr.responseText);
            }
          }
        };
        xhr.send(formData);
      });
    },
    async handleUploadImg(img, self, isCompress) {
      const fileType = getFileExtension(img);
      const vm = self;
      const file = img;
      const LENGTH = 1024 * 1024 * 0.2; // 0.5M每个chunk
      const that = this;
      let chunks = that.slice(file, LENGTH);
      // 获取对于同一个文件，获取其的context
      let context = that.createContext(file);
      // 获取上传记录
      let record = await that.getUploadSliceRecord(context, chunks);
      let tasks = [];
      vm.previewList.push(URL.createObjectURL(file));
      vm.showLoading = true;
      chunks.forEach((chunk, index) => {
        // 已上传的切片则不再重新上传
        if (!record.includes(index + 1)) {
          return;
        }
        let fd = new FormData();
        fd.append('file', chunk);
        fd.append('context', context);
        fd.append('chunk', index + 1);
        fd.append('type', 'support_order');
        fd.append('e_info', globalConfig.getHrefParam('e_info'));
        fd.append('user_id_cross', globalConfig.getHrefParam('uid') || '');
        fd.append(
          'login_account',
          globalConfig.getHrefParam('loginAccount') || ''
        );
        let task = that
          .post(
            'https://gsupport.' +
              globalConfig.getMainHost() +
              '/index/uploadImg2',
            fd
          )
          .then(res => {
            if (+res.result) {
              record.push(index);
            }
          });
        tasks.push(task);
      });
      // 所有切片上传完毕后，调用mkfile接口
      Promise.all(tasks)
        .then(res => {
          let fd = new FormData();
          fd.append('context', context);
          fd.append('chunks', chunks.length);
          that
            .post(
              'https://gsupport.' +
                globalConfig.getMainHost() +
                '/index/mkFile',
              fd
            )
            .then(res => {
              let url = (res.data && res.data?.IMG_URL[0]) || '';
              if (res.result === 1) {
                vm.showLoading = false;
                vm.workParams.pic.push(url);
                vm.workParams.pic_compress.push(+isCompress);
              } else {
                vm.showLoading = false;
                vm.toast(res?.msg);
              }
            });
        })
        .catch(error => {
          console.error(error);
        });
    },
    // 获取未上传切片记录
    async getUploadSliceRecord(context, chunks) {
      let fd = new FormData();
      fd.append('context', context);
      fd.append('chunks', chunks.length);
      const response = await this.post(
        'https://gsupport.' +
          globalConfig.getMainHost() +
          '/index/getUnUploadChunks',
        fd
      );
      return +response.result === 1 ? response.data?.UnUploadChunks : [];
    },
    // 获取context，同一个文件会返回相同的值
    createContext(file) {
      return file.name + file.size;
    },
    // 切片
    slice(file, piece = 1024 * 1024 * 5) {
      let totalSize = file.size; // 文件总大小
      let start = 0; // 每次上传的开始字节
      let end = start + piece; // 每次上传的结尾字节
      let chunks = [];
      while (start < totalSize) {
        // 根据长度截取每次需要上传的数据
        // File对象继承自Blob对象，因此包含slice方法
        let blob = file.slice(start, end);
        chunks.push(blob);
        start = end;
        end = start + piece;
      }
      return chunks;
    },
    /* eslint-disable handle-callback-err */
    imageErrorHandle(err) {
      this[TOAST](this.letters._uploadTips);
    },
    deleteImage: function (i) {
      this.workParams.pic.splice(i, 1);
      this.workParams.pic_compress.splice(i, 1);
      this.previewList.splice(i, 1);
    },
    resetImage: function (i) {
      this.workParams.pic = [];
      this.workParams.pic_compress = [];
      this.previewList = [];
    },
    send: function () {
      let message = this.message;
      let support_order_id = this.work?.SUPPORT_ORDER_ID;
      let pic = JSON.stringify(this?.workParams?.pic);
      let pic_compress = JSON.stringify(this?.workParams?.pic_compress);
      this.message = '';
      this.transition = 'conversation';
      this.loading = true;
      this.sendMessage({
        support_order_id,
        message,
        pic,
        pic_compress
      }).then(
        function () {
          this.message = '';
          this.loading = false;
        }.bind(this)
      );
    }, // 发送消息
    toggleMarkScore: function () {
      this.openMarkScore = !this.openMarkScore;
    } // 切换评分弹窗
  },
  components: {
    markScore,
    container,
    VueCoreImageUpload
  }
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
.loading {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  background: rgba(0, 0, 0, 0.5);
  &-icon {
    @include size(50, 50);
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    @include bgPng('loading');
    display: inline-block;
    animation: circle linear 1s infinite;
  }
}
.dis {
  opacity: 0.5;
}
%portrait {
  position: absolute;
  top: 0;
  @include size(82, 82);
  display: inline-block;
}
.portrait-service {
  left: 0;
  @include bgPng('potrait-service');
  @extend %portrait;
}
.portrait-user {
  right: 0;
  @include bgPng('potrait-user');
  @extend %portrait;
}
.triangle-right {
  &::before {
    content: '';
    display: block;
    position: absolute;
    right: -20px;
    top: 10px;
    border-left: solid 10px #dfdfdf;
    border-right: solid 10px transparent;
    border-bottom: solid 10px transparent;
    border-top: solid 10px transparent;
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    right: -18px;
    top: 10px;
    border-left: solid 10px #fff;
    border-right: solid 10px transparent;
    border-bottom: solid 10px transparent;
    border-top: solid 10px transparent;
    z-index: 2;
  }
}
.triangle-left {
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: -20px;
    top: 10px;
    border-right: solid 10px #dfdfdf;
    border-left: solid 10px transparent;
    border-bottom: solid 10px transparent;
    border-top: solid 10px transparent;
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    left: -18px;
    top: 10px;
    border-right: solid 10px #fff;
    border-left: solid 10px transparent;
    border-bottom: solid 10px transparent;
    border-top: solid 10px transparent;
    z-index: 2;
  }
}
/*主题内容样式*/
.ceate-time {
  width: 100%;
  line-height: 80px;
  text-align: center;
  position: relative;
  margin-top: -80px;
  flex: 0 1 auto;
}
.conversation {
  width: 100%;
  height: 100%;
  padding-top: 80px;
  border-bottom: solid 240px transparent;
  position: relative;
  overflow-y: scroll;
  transition: all 0.3s;
  user-select: auto !important;
  -webkit-user-select: auto !important;
  -moz-user-select: auto !important;
  -ms-user-select: auto !important;
  &.resolved {
    border-bottom-width: 30px;
  }
  &-work {
    padding-right: 95px;
    position: relative;
    flex: 0 1 auto;
  }
  &-main {
    &-item {
      position: relative;
      margin-top: 30px;
      padding-right: 95px;
    }
  }
  &-feedback {
    text-align: center;
    margin-top: 30px;
  }
}
// 上传列表
.img-preview-list {
  transition: all 0.3s;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 125px;
  padding: 0 30px;
  &-item {
    @include size(100, 100);
    position: relative;
    margin-right: 30px;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
      display: inline-block;
    }
    &-delete {
      @include size(30, 30);
      display: inline-block;
      @include bgPng('delete-icon');
      position: absolute;
      top: -8px;
      right: -8px;
      z-index: 9;
    }
  }
  .limit {
    margin-top: 15px;
    font-size: 24px;
    color: #7a7a7a;
  }
}
.upload-image-btn {
  @include size(100, 100);
  display: inline-block;
  position: relative;
  @include bgPng('add-icon');
  background-size: 30px 30px;
  background-position: center center;
  @include bgC(#dfdfdf);
}
.btn-primary {
  transition: all 0.3s;
  width: 100px;
  display: inline-block;
  vertical-align: bottom;
}
.send {
  width: 100%;
  height: 110px;
  position: fixed;
  bottom: 0px;
  padding: 0 30px;
  left: 0;
  z-index: 9;
  background: #fff;
  input {
    width: 67%;
    height: 80px;
    background-color: #f3f3f3;
    padding-left: 30px;
  }
  button {
    width: 32%;
    height: 80px;
    background-color: #5fd193;
    color: #fff;
  }
}
.work-card {
  width: 100%;
  height: auto;
  border: solid 1px #dfdfdf;
  padding: 32px;
  position: relative;
  border-radius: 10px;
  &-user {
    line-height: 60px;
  }
  &-message {
    width: 100%;
    line-height: 37.5px;
    overflow: hidden;
    @include cut-text(4);
    display: inline-block;
  }
  &-images {
    width: 100%;
    height: auto;
    margin-top: 30px;
    img {
      @include size(110, 110);
      display: inline-block;
      margin-right: 20px;
    }
  }
}
.service {
  padding-left: 95px;
}

@media screen and (orientation: landscape) {
  .conversation-send {
    input {
      width: 50%;
    }
    button {
      width: 50%;
    }
  }
}

.is-in-sdk {
  $safeBottomDis: 60px;
  padding-bottom: $safeBottomDis !important;

  .img-preview-list {
    bottom: 125px + $safeBottomDis;
  }

  .send {
    bottom: $safeBottomDis;
  }
}
</style>
